class FAQContainer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        $(this).find('.faq-item-question').on('click', this.toggleAnswer.bind(this));
    }

    disconnectedCallback() {
        $(this).find('.faq-item-question').off('click', this.toggleAnswer.bind(this));
    }

    toggleAnswer(event) {
        const $question = $(event.currentTarget);
        const $item = $question.closest('.faq-item');
        const $answer = $item.find('.faq-item-answer');
        const duration = 400;

        if ($item.hasClass('active')) {
            $item.removeClass('active');
            $answer.slideUp(duration);
        } else {
            $item.addClass('active');
            $answer.slideDown(duration);
        }
    }
}

customElements.define('faq-container', FAQContainer);